import { GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import ClipboardButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/clipboard_button.vue?vue3';
import SourceEditor from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/source_editor.vue?vue3';
export default {
    name: 'FormFlowConfiguration',
    components: {
        ClipboardButton,
        GlButton,
        SourceEditor
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'input'
    ],
    computed: {
        editorOptions () {
            return {
                padding: {
                    top: 4
                },
                readOnly: this.readOnly
            };
        }
    },
    methods: {
        onInput (val) {
            this.$emit('input', val);
        },
        clearValue (event) {
            const editor = this.$refs.editor.getEditor();
            if (editor) {
                const model = editor.getModel();
                if (model) {
                    editor.executeEdits('clear-button', [
                        {
                            range: model.getFullModelRange(),
                            text: ''
                        }
                    ]);
                    if (typeof event === 'undefined' || event.detail !== 0) {
                        // only focus when the user clicked the button with mouse or touchpad
                        // when user hit enter to click the button, the focus stays there.
                        editor.focus();
                    }
                }
            }
        }
    },
    configFile: 'config.yaml'
};
